<eif-counter-card
	[value]="value"
	[sublabel]="sublabel"
	[label]="(config.label | translate) + labelSuffixText"
	[icon]="config.icon"
	[accent]="config.accent"
	[loading]="loading"
	[hasAction]="showAction"
	(action)="action.emit()" />
